import { render, staticRenderFns } from "./PackateryPersonalCollection.vue?vue&type=template&id=0482fc77"
import script from "./PackateryPersonalCollection.vue?vue&type=script&lang=ts"
export * from "./PackateryPersonalCollection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports